import {Dispatch} from 'react'
import * as validators from '../../utils/validaciones'
import * as reg from '../../constants/Regex'
import {State} from '../../reducers'
import {OlvidoPassAction} from '../../interfaces/olvidoPass.interface'
import {
  olvidoPassFormRestablecerHandleChange,
  olvidoPassFormVerificarHandleChange,
} from './olvidoPass.actions'
import {OLVIDO_PASS_TYPES} from '../../constants/olvidoPass.types'
import {DICCIONARIO} from '../../constants/Diccionario'

// ******************************************************************************************

// ******************************************************************************************
// ? VALIDACIONES
// ******************************************************************************************

export const olvidoPassFormPasswordHandleChange = (error: any) => ({
  type: OLVIDO_PASS_TYPES.FORM_PASSWORD_ADD_ERRORS,
  payload: error,
})

// *********************************************************************************
// Validaciones Formulario Restablecer
// *********************************************************************************
export const opValidacionesOnBlurFormRestablecer =
  (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) =>
  async (dispatch: Dispatch<OlvidoPassAction>) => {
    let {name, value} = e.target
    let message = ''
    switch (name) {
      case 'email':
        message = validators.validacionEsRequerido(value, message, DICCIONARIO.USERNAME)
        if (!message) message = validators.validacionMinLenght(value, message, 2)
        break
      case 'telefono':
        message = validators.validacionEsRequerido(value, message, 'Teléfono celular')
        if (!message) message = validators.validacionMinLenght(value, message, 8)
        if (!message)
          message = validators.validacionRegex(
            reg.REGEX_TELEFONO,
            value,
            message,
            'Teléfono celular'
          )
        break
      default:
        break
    }

    dispatch(olvidoPassFormRestablecerHandleChange({error: message}))
  }

export const opValidacionesFormRestablecerEnviar =
  () => async (dispatch: Dispatch<OlvidoPassAction>, getState: () => State) => {
    let form = getState().olvidoPass.formRestablecer

    if (form.tipo === OLVIDO_PASS_TYPES.INPUT_EMAIL) {
      form.error = validators.validacionEsRequerido(form.email, form.error, DICCIONARIO.USERNAME)
      if (!form.error) form.error = validators.validacionMinLenght(form.email, form.error, 2)
    } else {
      form.error = validators.validacionEsRequerido(form.telefono, form.error, 'Teléfono celular')
      if (!form.error) form.error = validators.validacionMinLenght(form.telefono, form.error, 8)
      if (!form.error)
        form.error = validators.validacionRegex(
          reg.REGEX_TELEFONO,
          form.telefono,
          form.error,
          'Teléfono celular'
        )
    }

    dispatch(olvidoPassFormRestablecerHandleChange({error: form.error}))
    if (form.error) return true
    return false
  }

// *********************************************************************************
// Validaciones Formulario CODIGO DE VERIFICACIÓN
// *********************************************************************************
export const opValidacionesOnBlurFormVerificacion =
  (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) =>
  async (dispatch: Dispatch<OlvidoPassAction>) => {
    let {name, value} = e.target
    let message = ''
    switch (name) {
      case 'code':
        message = validators.validacionEsRequerido(value, message, 'Código de verificación')
        break
      default:
        break
    }
    dispatch(olvidoPassFormVerificarHandleChange({error: message}))
  }

export const opValidacionesFormVerificacionEnviar =
  () => async (dispatch: Dispatch<OlvidoPassAction>, getState: () => State) => {
    let {code, error} = getState().olvidoPass.formVerificar

    error = validators.validacionEsRequerido(code, error, 'Código de verificación')

    dispatch(olvidoPassFormVerificarHandleChange({error}))
    if (error) return true
    return false
  }

// *********************************************************************************
// Validaciones Formulario Password
// *********************************************************************************
export const opValidacionesFormPasswordOnBlur =
  (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) =>
  async (dispatch: Dispatch<OlvidoPassAction>) => {
    let {name, value} = e.target
    let message = ''
    switch (name) {
      case 'passwd':
        message = validators.validacionEsRequerido(
          value,
          message,
          DICCIONARIO.PASSWORD,
          'requerida'
        )
        if (!message) message = validators.validacionPassword(value, message, DICCIONARIO.PASSWORD)
        break
      case 'passwd2':
        message = validators.validacionEsRequerido(
          value,
          message,
          DICCIONARIO.CONFIRM_PASSWORD,
          'requerida'
        )
        if (!message)
          message = validators.validacionPassword(value, message, DICCIONARIO.CONFIRM_PASSWORD)
        break
      default:
        break
    }

    dispatch(olvidoPassFormPasswordHandleChange({[name]: message}))
  }

export const opValidacionesFormPasswordEnviar =
  () => async (dispatch: Dispatch<OlvidoPassAction>, getState: () => State) => {
    let {formPassword: formUser, errorFormPassword: formError} = getState().olvidoPass
    let errors = formError

    errors.passwd = validators.validacionEsRequerido(
      formUser.passwd,
      errors.passwd,
      DICCIONARIO.PASSWORD,
      'requerida'
    )
    if (!errors.passwd)
      errors.passwd = validators.validacionPassword(
        formUser.passwd,
        errors.passwd,
        DICCIONARIO.PASSWORD
      )

    errors.passwd2 = validators.validacionEsRequerido(
      formUser.passwd2,
      errors.passwd2,
      DICCIONARIO.CONFIRM_PASSWORD,
      'requerida'
    )
    if (!errors.passwd2)
      errors.passwd2 = validators.validacionPassword(
        formUser.passwd2,
        errors.passwd2,
        DICCIONARIO.CONFIRM_PASSWORD
      )

    if (formUser.passwd2 && formUser.passwd && formUser.passwd2 !== formUser.passwd)
      errors.passwd2 = 'Las contraseñas no coinciden'

    dispatch(olvidoPassFormPasswordHandleChange(errors))
    if (errors.passwd || errors.passwd2) return true
    return false
  }
